export default "__VITE_ASSET__ByJSVszR__"